import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=1177e258"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports